/**
 * Copia de los formularios de la tienda al back-office.
 *
 * Va en el tema de Shopify (`tienda/assets/`). El formulario sigue enviándose
 * a Shopify exactamente igual —el correo a tiendapico@gmail.com no se toca—,
 * y además manda una copia al panel. Si el panel está caído, el envío del
 * cliente NO se rompe: solo se pierde la copia.
 *
 * La URL del panel se pasa por data-atributo desde el Liquid para no tener
 * dominios escritos en el JavaScript.
 */

(() => {
  const formulario = document.querySelector('[data-pico-copia]');
  if (!formulario) return;

  const destino = formulario.dataset.picoCopia;
  if (!destino) return;

  const valor = (nombre) => {
    const campo = formulario.querySelector(`[name="contact[${nombre}]"]`);
    if (!campo) return undefined;
    if (campo.type === 'checkbox') return campo.checked;
    return campo.value.trim() || undefined;
  };

  formulario.addEventListener('submit', () => {
    const mensaje = valor('body');
    if (!mensaje) return; // sin mensaje no hay nada que copiar

    const datos = {
      tipo: 'contacto',
      nombre: valor('name'),
      email: valor('email'),
      telefono: valor('phone'),
      mensaje,
      aceptaPrivacidad: valor('Acepta la politica de privacidad') === true,
      aceptaPromociones: valor('Acepta recibir promociones') === true,
      paginaOrigen: window.location.href,
      web: formulario.querySelector('[name="pico-web"]')?.value || undefined,
    };

    try {
      // keepalive: el formulario de Shopify navega a otra página al enviarse;
      // sin esto el navegador cancelaría la petición a medio camino.
      fetch(destino, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos),
        keepalive: true,
        mode: 'cors',
      }).catch(() => {
        /* el envío a Shopify sigue su curso: la copia es lo secundario */
      });
    } catch {
      /* ningún fallo aquí puede impedir que el cliente envíe su mensaje */
    }
  });
})();
